import React, {Component} from 'react'
import { DropdownButton, MenuItem, FormControl } from 'react-bootstrap';

const Item = (props) => {
  const {val, fieldPropLabel, onSelect, expand, navigatedTo} = props
  if(val.object){
    return (
      <MenuItem value="" onClick={expand}
        style={{
          paddingLeft: val.iteration*15,background:navigatedTo?'#deedf8':'white'
        }}>
          <span className="expander-circle" 
            style={{lineHeight:val.isExpanded ? '10px':'12px' }}>
            {val.isExpanded ? '-':'+'}
          </span>
          <span style={{textDecoration:'underline',color:'#999999',fontWeight:'bold'}}>
            {val.title}
          </span>
      </MenuItem>
    )
  }
  return(
    <MenuItem value={val[fieldPropLabel]} onClick={onSelect} 
      style={{paddingLeft:(val.iteration*15||0) + 
        (val.parentRef ? val.parentRef.length * 15 + 8 : 0), 
        marginLeft:val.isSelected?-15:0,
        background:navigatedTo?'#deedf8':'white'
      }}>
      {val.isSelected?'✔ ':''} {val.title}
    </MenuItem>
  )
}

class Select extends Component {

  constructor(){
    super()
    this.state={
      open:false,
      navIndex:0
    }
  }

  componentDidMount(){
    if(this.props.autoOpen){
      this.setState({open:true})
    }
  }

  toggle = (e) => {
    if(!this.props.disabled){
      this.setState({open:e})
    }
  }

  close = () => {
    this.setState({open:false,navIndex:0})
  }

  onNav = (direction,length) => { // 'up' or 'down'
    const go={
      up:-1,
      down:1,
    }
    const newNavIndex = Math.min(
      Math.max(
        this.state.navIndex + go[direction], 
      0), 
    length-1)
    this.setState({navIndex:newNavIndex},()=>{
      this.navScroll()
    })    
  }

  navScroll = () => { // 273
    const {navIndex} = this.state
    const ulNode = this.wrapRef.childNodes[0].childNodes[1]
    const liHeight = 26
    const liToTop = Math.max((navIndex-9)*liHeight,0)
    const top = ulNode.scrollTop
    const bottom = top+273
    if(liToTop>bottom && liToTop<top){
      // within range
    } else {
      ulNode.scrollTop = liToTop
    }
  }

  render(){
    const { vals, onSelect, label, title, sectionLabelSuffix, style, onClick, disabled, dropup, extraClass, sectionLabels, fieldPropLabel, menuAlign, 
      type, expand, wrapClass, size, changeSearchTerm } = this.props
    const {navIndex} = this.state

    const values = []
    vals.forEach((v)=>{
      if(!v[fieldPropLabel]){
        values.push(v)
      }
      if(v.satisfiesSearch){
        values.push(v)
      }
    })

    const extraClassy = extraClass ? ' extra-select-button-class' : ''
    return(
      <div onClick={onClick} style={{display:'inline-block', marginRight:12}} 
        className={`lingk-dropdown-menu-wrapper${wrapClass?' '+wrapClass:''}`}>
        {title && <span><label className="labelz" style={{marginLeft:4}}>
          {title}</label><br/></span>}
        <div ref={ref=>this.wrapRef=ref}>
          <DropdownButton placeholder={label} value={label} bsSize={size}
            bsStyle={type==='brand'?'primary':'default'} dropup={dropup}
            style={style} className={`select-button${extraClassy}`}
            title={label} id={`select-${label}`} pullRight={menuAlign==='right'}
            disabled={disabled} onToggle={this.toggle}
            open={disabled?false:this.state.open}
          >
            {!sectionLabels ?
              values && values.map((val, i)=>
                <Item val={val} fieldPropLabel={fieldPropLabel} key={i}
                  onSelect={()=>onSelect(val[fieldPropLabel], i, val)} />
              )
            : values && values.map((val, i)=>{
                if(!val[fieldPropLabel]){
                  return <MenuItem key={i} value="" disabled icon="none" 
                    style={{background:'#EEEEEE', color:'#AAAAAA', fontWeight:'bold'}}>
                      <span>{`${val} ${sectionLabelSuffix}`}</span>
                      {this.state.open && <Searcher changeSearchTerm={changeSearchTerm} 
                        sectionLabel={val} i={i} 
                        onNav={(d)=>this.onNav(d,values.length)} 
                        onEnter={()=>{
                          const val = values[navIndex]
                          if(val[fieldPropLabel]){
                            if(val.object){
                              expand(val[fieldPropLabel], val.parents)
                            } else {
                              onSelect(val[fieldPropLabel], navIndex, val)
                              this.close()
                            }
                          }
                        }}
                      />}
                  </MenuItem>
                } else return <Item val={val} fieldPropLabel={fieldPropLabel} key={i}
                  expand={()=>expand(val[fieldPropLabel], val.parents)} 
                  onSelect={()=>onSelect(val[fieldPropLabel], i, val)} 
                  navigatedTo={this.state.navIndex===i}
                />
              })
            }
          </DropdownButton>
        </div>
      </div>
    )
  }
}

export default Select


class Searcher extends Component {
  
  componentDidMount(){
    if(this.props.i===0){ // only focus the top one
      this.inputRef.focus()
    }
  }

  onKeyDown = (e) => {
    e.stopPropagation()
    const keyCodes = {
      38:'up',
      40:'down',
    }
    if(keyCodes[e.keyCode]){
      this.props.onNav(keyCodes[e.keyCode])
    }
    if(e.keyCode===13){
      e.preventDefault() // prevent open
      this.props.onEnter()
    }
  }

  render(){
    const {changeSearchTerm, sectionLabel} = this.props
    return (<div style={{display:'inline-block',margin:'0 20px',position:'relative'}}>
      <FormControl type="text" style={{height:24, width:100, display:'inline-block'}}
        onChange={(e)=>changeSearchTerm(e.target.value, sectionLabel)}
        inputRef={(ref)=>{ this.inputRef=ref }}
        onKeyDown={this.onKeyDown}
      />
      <svg fill="#777" height="20" viewBox="0 0 24 24" width="20" 
        style={{position:'absolute',top:4,marginLeft:5}}>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </div>)
  }
}





// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Select.js